module.exports = __webpack_public_path__ + "public/img/sk1.f6aa2ea5.png";